<template>
  <div class="weixin" id="weixin" v-close="close">
    <div id="weixin-ios" v-show="oIos">
      <img src="../assets/image/comment/weixin-ios.png" style="width:100%" alt="">
    </div>
    <div id="weixin-android" v-show="oAndroid">
      <img src="../assets/image/comment/weixin-android.png" style="width:100%" alt="">
    </div>
  </div>
</template>

<script>
  import Bus from './eventBus.js'
  export default {
    name: 'weixinTip',
    directives: {
      //关闭提示的指令
      close: {
        bind: function (el, binding) {
          document.addEventListener('click', binding.value, false)
        }
      }
    },
    data: function () {
      return {
        oIos: false,
        oAndroid: false
      }
    },
    created: function () {
      var that = this
      Bus.$on('openWeixinIos', target => {
        that.oIos = true
      })
      Bus.$on('openWeixinAndroid', target => {
        that.oAndroid = true
      })
    },
    methods: {
      close: function () {
        this.oIos = false
        this.oAndroid = false
      }
    }
  }
</script>

<style scoped>
  .weixin{
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
  }
</style>



// WEBPACK FOOTER //
// src/components/weixinTip.vue